import { addMinutes, getDay, format } from 'date-fns';

const WEEKEND_DAYS = [0, 5, 6]; // Sun, Fri, Sat

export function calculatePrice(eventType, startDate, endDate, rules, addOns = [], selectedAddOnIds = []) {
  if (!startDate || !endDate) return { subtotal: 0, addOnsTotal: 0, totalPrice: 0, depositAmount: 0, balanceDue: 0 };

  const start = new Date(startDate);
  const end = new Date(endDate);
  if (end <= start) return { subtotal: 0, addOnsTotal: 0, totalPrice: 0, depositAmount: 0, balanceDue: 0 };

  let subtotal = 0;

  if (eventType.isFlatPackage && eventType.flatPackagePrice != null) {
    subtotal = eventType.flatPackagePrice;
  } else {
    let current = new Date(start);
    while (current < end) {
      const chunkEnd = addMinutes(current, 30);
      const dayOfWeek = getDay(current);
      const timeString = format(current, 'HH:mm');

      const matchingRule = rules.find(rule => {
        if (rule.eventTypeId && rule.eventTypeId !== eventType.id) return false;
        if (rule.days && !rule.days.includes(dayOfWeek)) return false;
        if (rule.startTime && rule.endTime) {
          return timeString >= rule.startTime && timeString < rule.endTime;
        }
        return true;
      });

      const hourlyRate = matchingRule ? matchingRule.hourlyRate : (eventType.baseRate || 0);
      subtotal += (hourlyRate / 2);
      current = chunkEnd;
    }

    // Apply full-day cap
    const bookingDay = getDay(start);
    const isWeekend = WEEKEND_DAYS.includes(bookingDay);
    const cap = isWeekend ? eventType.fullDayCapWeekend : eventType.fullDayCapWeekday;
    if (cap != null && subtotal > cap) {
      subtotal = cap;
    }
  }

  // Calculate add-ons total
  const durationHours = (end - start) / (1000 * 60 * 60);
  let addOnsTotal = 0;
  selectedAddOnIds.forEach(id => {
    const addon = addOns.find(a => a.id === id);
    if (addon) {
      if (addon.type === 'flat') addOnsTotal += addon.price;
      if (addon.type === 'hourly') addOnsTotal += addon.price * durationHours;
    }
  });

  const totalPrice = subtotal + addOnsTotal;
  const depositAmount = Math.round(subtotal * 0.5 * 100) / 100;
  const balanceDue = Math.round((totalPrice - depositAmount) * 100) / 100;

  return {
    subtotal,
    addOnsTotal,
    totalPrice,
    depositAmount,
    balanceDue,
  };
}
